export { default as IconComponent } from './IconComponent';
